import { useEffect, useState } from "react";

/**
 * ページの閲覧進捗を、日本からアメリカへ向かう飛行機で表す細いバー。
 * スクロール量にそのまま連動するだけで、自動で動き続けることはない。
 * 装飾要素のため読み上げ対象からは外している。
 */
export default function FlightProgress() {
  const [progress, setProgress] = useState(0);
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReducedMotion(query.matches);
    const onChange = (event: MediaQueryListEvent) => setReducedMotion(event.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  useEffect(() => {
    let frame = 0;

    const update = () => {
      frame = 0;
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const next = max > 0 ? window.scrollY / max : 0;
      setProgress(Math.min(1, Math.max(0, next)));
    };

    const schedule = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);

    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
    };
  }, []);

  // 端で飛行機がはみ出さないように、4%〜96%の範囲で動かす
  const planeLeft = `${4 + progress * 92}%`;
  const filledWidth = `${progress * 100}%`;

  return (
    <div
      aria-hidden="true"
      className="w-full border-t border-background-200/70 bg-background-50/90"
    >
      <div className="mx-auto flex h-[16px] w-full max-w-content items-center gap-2 px-5 md:h-[24px] md:gap-3 md:px-6">
        <span className="shrink-0 text-[9px] leading-none md:text-[11px]">🇯🇵</span>

        <div className="relative h-[2px] flex-1 rounded-full bg-background-200">
          <span
            className="absolute inset-y-0 left-0 rounded-full bg-primary-300"
            style={{ width: filledWidth }}
          />
          {!reducedMotion && (
            <span
              className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 text-[9px] leading-none md:text-[12px]"
              style={{ left: planeLeft }}
            >
              ✈️
            </span>
          )}
        </div>

        <span className="shrink-0 text-[9px] leading-none md:text-[11px]">🇺🇸</span>
      </div>
    </div>
  );
}